import {
  AdddestinationCountryData,
  FeeLookupSuccess,
  SendCommitSuccess,
  SendValidate,
  SendValidateSuccess,
  GetRefundSuccess,
  TransactionStatusSuccess,
  PrepareTransaction,
  SetLocationActionTrns,
  ClearSelectedLocationAction,
  ConfirmRefundSuccess,
  setPaymentMethod,
} from './transaction.actions';
import { createReducer, on, Action } from '@ngrx/store';
import { _Bottom } from '@angular/cdk/scrolling';
import { RefundResponse, TransactionState } from './types';
import { DpSendCommitSuccess, DpSendValidate, DpSendValidateSuccess } from '../digital-payment/digital-payment.action';

export const initialState: TransactionState = {
  // TODO -- fix typing
  destinationCountryData: {} as any,
  feeLookupResponse: {} as any,
  sendValidateRequest: {} as any,
  sendValidateResponse: {} as any,
  sendCommitResponse: {} as any,
  getRefundResponse: {} as RefundResponse,
  confirmRefundResponse: {} as any,
  selectedLocation: {} as any,
  paymentMethod: null
};

export function TransactionReducer(
  state: TransactionState | undefined,
  action: Action
) {
  return reducer(state, action);
}

export const reducer = createReducer(
  initialState,
  on(AdddestinationCountryData, (state, { destinationCountryData }) => ({
    ...state,
    destinationCountryData: {
      ...destinationCountryData,
    },
  })),
  on(
    setPaymentMethod,
    (state, { paymentMethod }) =>
      ({
        ...state,
        paymentMethod
      } as TransactionState)
  ),
  on(
    FeeLookupSuccess,
    (state, { feeLookupResponse }) =>
      ({
        ...state,
        feeLookupResponse: {
          ...feeLookupResponse,
        },
      } as TransactionState)
  ),
  on(SendValidate, (state, { transactionId, payload }) => ({
    ...state,
    sendValidateRequest: {
      ...payload,
    },
  })),
  on(DpSendValidate, (state, { sendValidatePayload }) => ({
    ...state,
    sendValidateRequest: {
      ...sendValidatePayload,
    },
  })),
  on(SendValidateSuccess, (state, { sendValidateResponse }) => ({
    ...state,
    sendValidateResponse: {
      ...sendValidateResponse,
    },
  })),
  on(DpSendValidateSuccess, (state, { sendValidateResponse }) => ({
    ...state,
    sendValidateResponse: {
      ...sendValidateResponse,
    },
  })),
  on(SendCommitSuccess, (state, { sendCommitResponse }) => ({
    ...state,
    sendCommitResponse: {
      ...sendCommitResponse,
    },
  })),
  on(DpSendCommitSuccess, (state, { sendCommitResponse }) => ({
    ...state,
    sendCommitResponse: {
      ...sendCommitResponse,
    },
  })),
  on(TransactionStatusSuccess, (state, { transactionStatusResponse }) => ({
    ...state,
    transactionStatusResponse: {
      ...transactionStatusResponse,
    },
  })),
  on(GetRefundSuccess, (state, { getRefundResponse }) => ({
    ...state,
    getRefundResponse: {
      ...getRefundResponse,
    },
  })),
  on(SetLocationActionTrns, (state, { selectedLocation }) => ({
    ...state,
    selectedLocation: selectedLocation,
  })),
  on(ClearSelectedLocationAction, (state) => ({
    ...state,
    selectedLocation: {},
  })),
  on(ConfirmRefundSuccess, (state, { confirmRefundResponse }) => ({
    ...state,
    confirmRefundResponse: confirmRefundResponse,
  }))
);
